import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import '../PageCss/HansaFlexIndiaPages/Journey.css';
import JourneyCard from '../../Components/JourneyCard/JourneyCard';

import JourneyCardR from '../../Components/JourneyCard/JourneyCardR';
import CenterStage from '../../Components/CenterStage/CenterStage';
import AOS from 'aos';
import 'aos/dist/aos.css';
import imgStage from '../../assets/management/stage3.jpg'
import imgHANSA_FLEX_SERBIA_STARTBRANCH from '../../assets/Journey/HANSA_FLEX_SERBIA_STARTBRANCH.webp'
import imgHANSA_FLEX_SERBIA_BRANCH_BEOGRAD_LESTLANE from '../../assets/Journey/HANSA_FLEX_SERBIA_BRANCH_BEOGRAD_LESTLANE.webp'
import imgHANSA_FLEX__BRANCH_SERBIA_UZICE from '../../assets/Journey/HANSA_FLEX__BRANCH_SERBIA_UZICE.webp'
import imgHANSA_FLEX__BRANCH_SERBIA_KRAJUJEVAC from '../../assets/Journey/HANSA_FLEX__BRANCH_SERBIA_KRAJUJEVAC.webp'
import imgHANSA_FLEX__BRANCH_SERBIA_ZELZNIC from '../../assets/Journey/HANSA_FLEX__BRANCH_SERBIA_ZELZNIC.webp'
import imgHANSA_FLEX__BRANCH_SERBIA_ZEMUN from '../../assets/Journey/HANSA_FLEX__BRANCH_SERBIA_ZEMUN.webp'
import imgHANSA_FLEX_BRANCH_SERBIA_NIS from '../../assets/Journey/HANSA_FLEX_BRANCH_SERBIA_NIS.webp'
import imgHANSA_FLEX_BRANCH_SERBIA_NOVISAD from '../../assets/Journey/HANSA_FLEX_BRANCH_SERBIA_NOVISAD.webp'
import imgHANSA_FLEX_BRANCH_SERBIA_VALJEVO from '../../assets/Journey/HANSA_FLEX_BRANCH_SERBIA_VALJEVO.webp'
import imgHANSA_FLEX_STARTOFCYLINDERCENTRE from '../../assets/Journey/HANSA_FLEX_STARTOFCYLINDERCENTRE.webp'
import imgSerbia_Zemun4 from '../../assets/management/Serbia_Zemun4.jpg';

function Journey() {

    const isMobile = window.innerWidth <= 789;

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
        AOS.init({
            // Global settings:
            disable: false,
            startEvent: 'DOMContentLoaded',
            initClassName: 'aos-init',
            animatedClassName: 'aos-animate',
            useClassNames: false,

            // Settings that can be overridden on per-element basis:
            offset: 300,
            delay: 0,
            duration: 500,
            easing: 'ease',
            once: false,
            mirror: false,
            anchorPlacement: 'top-bottom',
        });
    }, []);



    return (
        <div className='journey-content'>
            <CenterStage imageSrc={imgStage} title="Come with us on our Journey !" paragraph="HANSA-FLEX Serbia boasts a storied history defined by strategic evolution and adaptability. Over time, it has showcased resilience and innovation, adeptly surmounting obstacles while steadily broadening its impact within the industry." />

            <div className='div-timeline-wrapper'>
                <br /><br /><br /><br />
                {isMobile ? <></> : <><div className='vertical-line'></div></>}

                <div>
                    <JourneyCard
                        title="2001"
                        description="Start of HANSA-FLEX Serbia"
                        imageUrl={imgHANSA_FLEX_SERBIA_STARTBRANCH}
                        additionalDescription="Establishment of Operations in Serbia"
                    />
                </div>

                <div>
                    <JourneyCardR
                        title="2004"
                        description="Seat moved to Belgrade"
                        imageUrl={imgSerbia_Zemun4}
                        additionalDescription="Strategic Relocation"
                    />
                </div>

                <div>
                    <JourneyCard
                        title="2012"
                        description="New branch in Kragujevac"
                        imageUrl={imgHANSA_FLEX__BRANCH_SERBIA_KRAJUJEVAC}
                        additionalDescription="Regional Expansion Begins"
                    />
                </div>

                <div>
                    <JourneyCardR
                        title="2013"
                        description="New branch in Niš"
                        imageUrl={imgHANSA_FLEX_BRANCH_SERBIA_NIS }
                        additionalDescription="Continued Geographic Growth"
                    />
                </div>

                <div>
                    <JourneyCard
                        title="2015"
                        description="New branch in Novi Sad"
                        imageUrl={imgHANSA_FLEX_BRANCH_SERBIA_NOVISAD}
                        additionalDescription="Strengthening Presence in Northern Serbia"
                    />
                </div>

                <div>
                    <JourneyCardR
                        title="2017"
                        description="New branch in Železnik (Belgrade 2)"
                        imageUrl={imgHANSA_FLEX__BRANCH_SERBIA_ZELZNIC}
                        additionalDescription="Expansion within Belgrade Region"
                    />
                </div>

                <div>
                    <JourneyCard
                        title="2018"
                        description="New building for Zemun (Belgrade 1)"
                        imageUrl={imgHANSA_FLEX__BRANCH_SERBIA_ZEMUN}
                        additionalDescription="Infrastructure Development"
                    />
                </div>

                <div>
                    <JourneyCardR
                        title="2019"
                        description="Start of Cylinder Centre"
                        imageUrl={imgHANSA_FLEX_STARTOFCYLINDERCENTRE}
                        additionalDescription="Launch of Specialized Services"
                    />
                </div>

                <div>
                    <JourneyCard
                        title="2022"
                        description="2 new branches (Belgrade 3 and Valjevo)"
                        imageUrl={imgHANSA_FLEX_BRANCH_SERBIA_VALJEVO}
                        additionalDescription="Major Branch Expansion Phase I"
                    />
                </div>

                <div>
                    <JourneyCardR
                        title="2023"
                        description="2 new branches (Subotica and Užice)"
                        imageUrl={imgHANSA_FLEX__BRANCH_SERBIA_UZICE}
                        additionalDescription="Major Branch Expansion Phase II"
                    />
                </div>

            </div>
        </div>
    );
}

export default Journey;
